var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('fm-making-form', {
    ref: "generateForm",
    staticClass: "fm-making",
    attrs: {
      "preview": "",
      "generate-json": "",
      "generate-code": "",
      "clearable": "",
      "upload": "",
      "custom-fields": _vm.customFields,
      "global-config": _vm.globalConfig,
      "field-config": _vm.fieldConfig,
      "field-models": _vm.fieldModels,
      "data-source-set": _vm.dataSourceSet
    },
    on: {
      "ready": _vm.handleFormReady
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };